import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-decline",
  "use": "icon-arrow-decline-usage",
  "viewBox": "0 0 10 12",
  "content": "<symbol viewBox=\"0 0 10 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-decline\">\n<path d=\"M3.30717 6.41707L3.30717 0.670452C3.30717 0.351933 3.56729 0.0918093 3.88581 0.0918093H6.20038C6.5189 0.0918093 6.77903 0.351933 6.77903 0.670452L6.77903 6.41707H9.33249C9.65101 6.41707 9.91113 6.67454 9.91113 6.99571C9.91113 7.14966 9.85008 7.2983 9.74126 7.40713L5.40674 11.739C5.18112 11.9646 4.81483 11.9646 4.58921 11.739L0.257346 7.40448C0.0317287 7.17886 0.0317287 6.81256 0.257346 6.58694C0.366174 6.47812 0.514816 6.41707 0.668767 6.41707H3.30717Z\" fill=\"#F53F3F\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow-decline.svg
// module id = CBWe
// module chunks = 262